
export default (string) => {
    const firstLetter = string.slice(0,1).toUpperCase()
    const word = string.slice(1,string.length).toLowerCase()

    return `${firstLetter}${word}`
}